/* eslint-disable */
// ###########################################################
import React, { useState, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Modal from '../../ReusableTable/DssModel/DssModel';
import { MESSAGE_TYPE } from '../../../constants';
import ColumnSelector from '../../ReusableTable/DssColumnSelectionModal/ColumnSelectionModal';
import './GLReusableTable.css';
import swal from 'sweetalert';
import config from '../../../config/config';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import HtmlComp from '../../ReusableTable/DssHtmlComp/DssHtmlComp';

const { API_BASE_URL } = config;

const GLReusableTable = ({ data, columns, itemsPerPage, onPageChange, isCustomOpen, totalRecords, handleCSVDownload, dataLoading, onSelectedColumnsChange }) => {
    const { showPopup } = usePopupManager();
    const [currentPage, setCurrentPage] = useState(0);
    const [currentData, setCurrentData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.accessor));
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    // eslint-disable-next-line no-unused-expressions, no-undef
    const UserToken = keycloak.token;
    let username = '';
    let Email = '';

    if(UserToken !== undefined || UserToken !== null){
    const decoded = jwt_decode(UserToken);
    // eslint-disable-next-line
    username = decoded.preferred_username
    Email = decoded.email
    } else{
    console.log("test null..!")
    }

    useEffect(() => {
        const offset = currentPage * itemsPerPage;
        setCurrentData(data);
        setSelectedRows(selectedRows.filter(rowId => data.slice(offset, offset + itemsPerPage).some(row => row.id === rowId)));
    }, [currentPage, data, itemsPerPage]);
    

    const handlePageClick = ({ selected }) => {
        console.log(`Page clicked: ${selected + 1}`);
        setCurrentPage(selected);
        onPageChange(selected + 1);
    };

    const handleColumnChange = (newSelectedColumns) => {
        setSelectedColumns(newSelectedColumns);
        setIsModalOpen(false);
        if (onSelectedColumnsChange) {
            onSelectedColumnsChange(newSelectedColumns);
        }
    };

    const handleRowSelect = (id) => {
        setSelectedRows(prevSelectedRows =>
            prevSelectedRows.includes(id)
                ? prevSelectedRows.filter(rowId => rowId !== id)
                : [...prevSelectedRows, id]
        );
    };

    const handleSelectAll = () => {
        if (currentData.every(row => selectedRows.includes(row.id))) {
            setSelectedRows(selectedRows.filter(id => !currentData.some(row => row.id === id)));
        } else {
            setSelectedRows([...selectedRows, ...currentData.filter(row => !selectedRows.includes(row.id)).map(row => row.id)]);
        }
    };

    const filteredColumns = columns.filter(col => selectedColumns.includes(col.accessor));

    const stylesloading = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
            zIndex: 1000,
            flexDirection: 'column',
        },
        spinner: {
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #000',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            marginBottom: '20px',
        },
        '@keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
        },
    };

    return (
        <div>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', marginLeft:"5px" }}>
                <p className="total-records" style={{ margin: 0, fontWeight:"650", color:"#4A6FA5" }}>Total Records: {totalRecords}</p>
            </div> */}
            <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',marginBottom: '10px',marginLeft: "5px",flexWrap: "wrap"}}>
                <p className="total-records" style={{margin: 0,fontWeight: "650",color: "#4A6FA5"}}>
                    Total Records: {totalRecords}
                </p>
                <div style={{display: "flex",flexWrap: "wrap",gap: "15px",alignItems: "center"}}>
                    <div style={{display: "flex", alignItems: "center",fontSize: "13px",fontWeight: "500"}}>
                        <span style={{width: "14px",height: "14px",backgroundColor: "#4ADE80",display: "inline-block",marginRight: "6px",borderRadius: "3px"}}></span>
                        <span style={{ color: "#333", marginRight: "8px" }}>SAP Field</span>
                        <span style={{width: "14px",height: "14px",backgroundColor: "#2563EB",display: "inline-block",marginRight: "6px",borderRadius: "3px"}}></span>
                        <span style={{ color: "#333", marginRight: "8px" }}>Manual File Upload</span>
                        <span style={{width: "14px",height: "14px",backgroundColor: "#FACC15",display: "inline-block",marginRight: "6px",borderRadius: "3px"}}></span>
                        <span style={{ color: "#333",marginRight: "8px" }}>System Calculated</span>
                    </div>
                </div>
            </div>
            <div className="table-container">
                {isCustomOpen ?  
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                {filteredColumns.map((col, index) => (
                                    // <th key={index}>{col.header}</th>
                                    <th key={index} style={{ color: col.fontColor || "#2c3e50" }}>
                                        {col.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {dataLoading ? (
                                <tr>
                                <td colSpan={filteredColumns.length + 1}>
                                    <div style={{ textAlign: 'center', padding: '20px' }}>
                                        <div className="text-center">
                                            <div className="spinner-border text-primary mb-3" role="status"></div>
                                            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading ...</p>
                                        </div>
                                    </div>
                                </td>
                                </tr>
                            ) : (
                                currentData.map((row, index) => (
                                    <tr key={row.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(row.id)}
                                                onChange={() => handleRowSelect(row.id)}
                                            />
                                        </td>
                                        {filteredColumns.map((col, colIndex) => (
                                            <td key={colIndex}>{row[col.accessor]}</td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    :
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                {columns.map((col, index) => (
                                    // <th key={index}>{col.header}</th>
                                    <th key={index} style={{ color: col.fontColor || "#2c3e50" }}>
                                        {col.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {dataLoading ? (
                                <tr>
                                <td colSpan={filteredColumns.length + 1}>
                                    <div style={{position: 'fixed',top: 0,left: 0,width: '100vw',height: '100vh',backgroundColor: 'rgba(255, 255, 255, 0.8)',zIndex: 9999,display: 'flex',flexDirection: 'column',justifyContent: 'center',alignItems: 'center',}}>
                                        <div className="text-center">
                                            <div className="spinner-border text-primary mb-3" role="status"></div>
                                            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
                                            
                                        </div>
                                    </div>
                                </td>
                                </tr>
                            ) : (
                                // {currentData.map((row, index) => (
                                currentData.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(row.id)}
                                                onChange={() => handleRowSelect(row.id)}
                                            />
                                        </td>
                                        {columns.map((col, colIndex) => (
                                            <td key={colIndex}>{row[col.accessor]}</td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                }
            </div>
            <div className="table-controls">
                {isCustomOpen &&
                    <>
                        <button onClick={handleCSVDownload} className="download-button">DATA DOWNLOAD</button>
                        <button onClick={() => setIsModalOpen(true)} className="open-modal-button">CUSTOMIZE TABLE</button>
                        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                            <ColumnSelector
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onColumnChange={handleColumnChange}
                            />
                        </Modal>
                    </>
                    
                }
                <div className="pagination-container">
                    <ReactPaginate
                        previousLabel="previous"
                        nextLabel="next"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={Math.ceil(totalRecords / itemsPerPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />
                </div>
            </div>
            {loading && (
                <div style={{position: 'fixed',top: 0,left: 0,width: '100vw',height: '100vh',backgroundColor: 'rgba(255, 255, 255, 0.8)',zIndex: 9999,display: 'flex',flexDirection: 'column',justifyContent: 'center',alignItems: 'center',}}>
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status"></div>
                        <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GLReusableTable;